import { render, staticRenderFns } from "./SalesDrive.vue?vue&type=template&id=21ae20d8&"
import script from "./SalesDrive.vue?vue&type=script&lang=js&"
export * from "./SalesDrive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports